import moment from 'moment';
import 'moment/locale/es';

import AddIcon from '@mui/icons-material/Add';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import IconButton from '@mui/material/IconButton';

import imgFood from '../../../assets/img/plato_demo.png';

import './CardMenu.scss';

moment.locale('es');

const ProgramMenuCard = ({ data, dayMenu, setDayMenu, yaEsta }) => {

    const selectMenu = () => {
        setDayMenu(prev => {
            const updatedMenu = { ...prev };
            (data.types || []).forEach(type => {
                if (updatedMenu[type]) {
                    updatedMenu[type] = [...updatedMenu[type], data];
                }
            });
            return updatedMenu;
        });
    };

    /* Cuándo salió por última vez. Sin esto, el catálogo es una lista de 222
       nombres sin memoria y los platos se repiten sin que nadie lo vea. */
    const ultima = data.ultimaVez ? moment(data.ultimaVez) : null;
    const dias = ultima ? moment().startOf('day').diff(ultima.startOf('day'), 'days') : null;

    return (
        <div className={`plato${yaEsta ? ' plato--puesto' : ''}`}>
            <figure>
                <img src={data.imageUrl ? data.imageUrl : imgFood} alt="" />
            </figure>

            <div className="plato__txt">
                <h4>{data.name}</h4>
                <p>
                    {/* Si ya está en este día, la fecha sobra y encima confunde:
                        la última vez que salió ES este mismo día. */}
                    {yaEsta
                        ? <b className="plato__puesto">Ya está en este día</b>
                        : ultima
                            ? <span className={dias != null && dias >= 0 && dias <= 14 ? 'plato__reciente' : ''}>
                                {/* "Salió" solo si ya pasó. Un plato programado para
                                    el jueves no "salió" el jueves todavía. */}
                                {dias != null && dias < 0 ? 'Programado el ' : 'Salió el '}
                                {ultima.format('D MMM')}
                                {dias === 0 ? ' · hoy' : ''}
                                {dias != null && dias > 0 && dias <= 60
                                    ? ` · hace ${dias} ${dias === 1 ? 'día' : 'días'}` : ''}
                              </span>
                            : <span>Nunca se ha programado</span>}
                </p>
            </div>

            <IconButton aria-label={`Agregar ${data.name}`} onClick={selectMenu} className="plato__add">
                {yaEsta ? <CheckRoundedIcon fontSize="small" /> : <AddIcon fontSize="small" />}
            </IconButton>
        </div>
    )
};

export default ProgramMenuCard;
